function normalizeText(text: string) {
	return text
		.toLowerCase()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "");
}

export function sortArrayByObject(array: Array<Record<string, unknown>>, objProp: string) {
	const arr = ref([]);

	function dynamicSort(property: string) {
		let sortOrder = 1;
		if (property[0] === "-") {
			sortOrder = -1;
			property = property.substr(1);
		}
		return function (a: Record<string, unknown>, b: Record<string, unknown>) {
			/* next line works with strings and numbers,
			 * and you may want to customize it to your needs
			 */
			const result =
				normalizeText(a[property] as string) < normalizeText(b[property] as string)
					? -1
					: normalizeText(a[property] as string) > normalizeText(b[property] as string)
					? 1
					: 0;
			return result * sortOrder;
		};
	}

	arr.value = (array as Array<Record<string, unknown>>).sort(dynamicSort(objProp));

	return arr;
}

export function sortArrayByObjectByLocale(array: Array<Record<string, unknown>>, objProp: string, locale: string) {
	const arr = ref([]);

	function dynamicSort(property: string) {
		let sortOrder = 1;
		if (property[0] === "-") {
			sortOrder = -1;
			property = property.substr(1);
		}
		return function (a: Record<string, unknown>, b: Record<string, unknown>) {
			/* next line works with strings and numbers,
			 * and you may want to customize it to your needs
			 */
			const result =
				normalizeText((a[property] as Record<string, string>)[locale]) <
				normalizeText((b[property] as Record<string, string>)[locale])
					? -1
					: normalizeText((a[property] as Record<string, string>)[locale]) >
					  normalizeText((b[property] as Record<string, string>)[locale])
					? 1
					: 0;
			return result * sortOrder;
		};
	}

	arr.value = (array as Array<Record<string, unknown>>).sort(dynamicSort(objProp));

	return arr;
}
